import type { PriceId } from '@iheartjane/types';
import get from 'lodash-es/get';

export const getMaxCartQuantity = (
  menuProduct: {
    max_cart_quantity?: number;
    max_cart_quantity_each?: number;
    max_cart_quantity_eighth_ounce?: number;
    max_cart_quantity_gram?: number;
    max_cart_quantity_half_gram?: number;
    max_cart_quantity_half_ounce?: number;
    max_cart_quantity_ounce?: number;
    max_cart_quantity_quarter_ounce?: number;
    max_cart_quantity_two_gram?: number;
  },
  weight: PriceId
): number | undefined => {
  return get(
    menuProduct,
    `max_cart_quantity_${weight}`,
    menuProduct.max_cart_quantity
  );
};
